import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-woman-development-cell',
  templateUrl: './woman-development-cell.component.html',
  styleUrls: ['./woman-development-cell.component.scss']
})
export class WomanDevelopmentCellComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
